export const getters = { 
  items: state => state.items,
  item: state => state.item,
  user: state => state.selectedUser,
  totalItems: state => state.totalItems,
  allUsers: state => state.allItems,
  error: state => ({ isError: state.isError, message: state.errorMessage })
};